import { ArvoreArquivoService } from './services/arvore-arquivos.service';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';

import { AppSessionService } from './session/app-session.service';
import { AppUrlService } from './nav/app-url.service';
import { AppAuthService } from './auth/app-auth.service';
import { LocalizePipe } from '@shared/pipes/localize.pipe';

import { AbpPaginationControlsComponent } from './components/pagination/abp-pagination-controls.component';
import { AbpValidationSummaryComponent } from './components/validation/abp-validation.summary.component';
import { AbpModalHeaderComponent } from './components/modal/abp-modal-header.component';
import { AbpModalFooterComponent } from './components/modal/abp-modal-footer.component';
import { LayoutStoreService } from './layout/layout-store.service';

import { BusyDirective } from './directives/busy.directive';
import { EqualValidator } from './directives/equal-validator.directive';

import { BuscaCnpjService } from './services/busca-cnpj.service';
import { BuscaCepService } from './services/busca-cep.service';
import { MercadoPagoService } from './services/mercado-pago.service';
import { TitleService } from './services/title.service';
import { PacienteService } from './services/paciente.service';
import { ProntuarioService } from './services/prontuario.service';
import { ClinicaService } from './services/clinica.service';
import { MonitoramentoService } from './services/monitoramento.service';
import { ValidarCpfService } from './services/validar-cpf.service';
import { StringExtensionService } from './services/string-extension.service';
import { DataService } from "./services/data.service"
import { BryService } from "./services/bry.service"
import { BryAuthService } from "./services/bry-auth.service";

import { NgxMaskModule } from 'ngx-mask';
import { FormatTimePipe } from './pipes/format-time.pipe';
import { ViewSituacaoPagamentoDialogComponent } from './views/view-situacao-pagamento/view-situacao-pagamento-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';

import { OnlyNumberDirective } from './directives/only-number.directive';
import { CpfCnpjValidator } from './directives/cpf-cnpj-validator.directive';
import { KsModalGalleryConfiguration } from './ks-modal-gallery-configuration';
import { OnlyAlphanumericDirective } from './directives/only-alphanumeric.directive';
import { RoleSelectionDialogComponent } from './components/role-selection-dialog/role-selection-dialog.component';
import { CustomModalComponent } from './components/custom-modal/custom-modal.component';
import { CustomModalBodyComponent } from './components/custom-modal/custom-modal-body/custom-modal-body.component';
import { CustomModalFooterComponent } from './components/custom-modal/custom-modal-footer/custom-modal-footer.component';
import { CustomModalHeaderComponent } from './components/custom-modal/custom-modal-header/custom-modal-header.component';
import { CustomTogleComponent } from './components/custom-togle/custom-togle.component';
import { CustomDropdownComponent } from './components/custom-dropdown/custom-dropdown.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { MaskPipe } from 'ngx-mask';
import { DefaultConveniosComponent } from './components/default-convenios/default-convenios.component';
import { ActiveConvenioComponent } from './components/default-convenios/active-convenio/active-convenio.component';
import { SuspendConvenioComponent } from './components/default-convenios/suspend-convenio/suspend-convenio.component';
import { EditConvenioComponent } from './components/default-convenios/edit-convenio/edit-convenio.component';
import { CreateConvenioComponent } from './components/default-convenios/create-convenio/create-convenio.component';
import { FormEnderecoComponent } from './components/form-endereco/form-endereco.component';
import { ShowDashIfNullPipe } from './pipes/show-dash-if-null.pipe';
import { CustomSetTextDialogComponent } from './components/custom-set-text-dialog/custom-set-text-dialog.component';
import { ChatComponent } from './components/chat/chat.component';
import { ChatCardComponent } from './components/chat/chat-card/chat-card.component';
import { ChatMessagesComponent } from './components/chat/chat-messages/chat-messages.component';
import { ChatService } from "./services/chat.service";
import { TipoAssinaturaService } from "./services/tipo-assinatura.service";
import { FotoPerfilService } from "./services/foto-perfil.service";
import { CountNotificationService } from "./services/count-notification.service";
import { PushNotficationService } from "./services/push-notfication.service";
import { CpfCnpjPipe } from './pipes/cpf-cnpj.pipe';
import { CustomCardComponent } from "./components/custom-card/custom-card.component";
import { CardDashboardComponent } from "./components/card-dashboard/card-dashboard.component";
import { CardInformacoesPacienteComponent } from './components/pacientes/card-informacoes-paciente/card-informacoes-paciente.component';
import { CustomCalendarComponent } from './components/custom-calendar/custom-calendar.component';
import { AgendaComponent } from './components/agenda/agenda.component';
import { CreateAgendaComponent } from './components/agenda/create-agenda/create-agenda.component';
import { EditAgendaComponent } from './components/agenda/edit-agenda/edit-agenda.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CreateEventoComponent } from './components/custom-calendar/create-evento/create-evento.component';
import { EditEventoComponent } from './components/custom-calendar/edit-evento/edit-evento.component';
import { CreateHorarioDisponivelComponent } from './components/custom-calendar/create-horario-disponivel/create-horario-disponivel.component';


import { DownloadFichaPacienteComponent } from './components/pacientes/download-ficha-paciente/download-ficha-paciente.component';
import { TelefonePipe } from './pipes/telefone.pipe';
import { DefaultPrescricoesComponent } from './components/default-prescricoes/default-prescricoes.component';
import { DefaultConsultasComponent } from './components/default-consultas/default-consultas.component';
import { DefaultConsultaComponent } from './components/default-consulta/default-consulta.component';
import { CreateConsultaComponent } from './components/default-consultas/create-consulta/create-consulta.component';
import { EditConsultaComponent } from './components/default-consultas/edit-consulta/edit-consulta.component';
import { EditStatusConsultaComponent } from './components/default-consultas/edit-status-consulta/edit-status-consulta.component';
import { VisualizarAnexosComponent } from './components/default-consultas/visualizar-anexos/visualizar-anexos.component';
import { ModalVisualizarAnexosComponent } from './components/default-consultas/modal-visualizar-anexos/modal-visualizar-anexos.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomDateAdapter, CUSTOM_DATE_FORMATS } from "./model/custom-date/custom-date-adapter.model";
import { CustomDatepickerSelectedComponent } from './components/custom-datepicker-selected/custom-datepicker-selected.component';
import { TornarPacienteVipComponent } from './components/pacientes/paciente-vip/tornar-paciente-vip/tornar-paciente-vip.component';
import { EditPacienteVipComponent } from './components/pacientes/paciente-vip/edit-paciente-vip/edit-paciente-vip.component';
import { DefaultAlergiasComponent } from './components/default-alergias/default-alergias.component';
import { CreateAlergiaComponent } from './components/default-alergias/create-alergia/create-alergia.component';
import { EditAlergiaComponent } from './components/default-alergias/edit-alergia/edit-alergia.component';
import { DefaultPacienteAlergiasComponent } from './components/default-paciente-alergias/default-paciente-alergias.component';
import { CreatePacienteAlergiaComponent } from './components/default-paciente-alergias/create-paciente-alergia/create-paciente-alergia.component';
import { EditPacienteAlergiaComponent } from './components/default-paciente-alergias/edit-paciente-alergia/edit-paciente-alergia.component';
import { VideoCallComponent } from './components/video-call/video-call.component';
import { VideoCallOptionsComponent } from './components/video-call/video-call-options/video-call-options.component';
import { RemarcarConsultaComponent } from './components/default-consultas/remarcar-consulta/remarcar-consulta.component';
import { CardPlanoAccountComponent } from './components/planos/card-plano-account/card-plano-account.component';
import { MinhaAssinaturaComponent } from './components/minha-assinatura/minha-assinatura.component';
import { CardPlanoComponent } from './components/planos/card-plano/card-plano.component';
import { RealizarPagamentoComponent } from './components/planos/realizar-pagamento/realizar-pagamento.component';
import { ExibirPlanoComponent } from './components/planos/exibir-plano/exibir-plano.component';
import { HistoricoAssinaturaComponent } from './components/minha-assinatura/historico-assinatura/historico-assinatura.component';
import { ViewCustoAdicionalComponent } from './components/view-custo-adicional/view-custo-adicional.component';
import { MetodosPagamentosComponent } from './components/metodos-pagamentos/metodos-pagamentos.component';
import { HistoricoCobrancaCustoAdicionalComponent } from './components/minha-assinatura/historico-cobranca-custo-adicional/historico-cobranca-custo-adicional.component';
import { ConveniosPacienteComponent } from './components/pacientes/convenios-paciente/convenios-paciente.component';
import { CreateConvenioPacienteComponent } from './components/pacientes/convenios-paciente/create-convenio-paciente/create-convenio-paciente.component';
import { EditConvenioPacienteComponent } from './components/pacientes/convenios-paciente/edit-convenio-paciente/edit-convenio-paciente.component';
import { CardConsultaModule } from './components/card-consulta/card-consulta.module';
import { ViewNotificacaoDialogComponent } from './components/view-notificacao-dialog/view-notificacao-dialog.component';
import { AnexarExameComponent } from './components/default-consultas/anexar-exame/anexar-exame.component';
import { BackButtonComponent } from './components/back/back-button.component';
import { GraficoHeaderComponent } from './components/grafico-header/grafico-header.component';
import { SuporteAssinaturaDigitalModalComponent } from './components/suporte-assinatura-digital-modal/suporte-assinatura-digital-modal.component';
import { PacienteMonitoradoComponent } from './components/paciente-monitorado/paciente-monitorado.component';
import { DashboardToggleComponent } from './components/dashboard-toggle/dashboard-toggle.component';
import { FormPacienteComponent } from './components/form-paciente/form-paciente.component';
import { VerificarCadastroPacienteComponent } from './components/form-paciente/components/verificar-cadastro-paciente/verificar-cadastro-paciente.component';
import { HeaderFormCadastroPacienteComponent } from './components/form-paciente/components/header-form-cadastro-paciente/header-form-cadastro-paciente.component';
import { DadosFormCadastroPacienteComponent } from './components/form-paciente/components/dados-form-cadastro-paciente/dados-form-cadastro-paciente.component';
import { DataNascimentoFormCadastroPacienteComponent } from './components/form-paciente/components/data-nascimento-form-cadastro-paciente/data-nascimento-form-cadastro-paciente.component';
import { ResponsavelFormCadastroPacienteComponent } from './components/form-paciente/components/responsavel-form-cadastro-paciente/responsavel-form-cadastro-paciente.component';
import { AceitaTermosFormCadastroPacienteComponent } from './components/form-paciente/components/aceita-termos-form-cadastro-paciente/aceita-termos-form-cadastro-paciente.component';
import { GerenciarDisponibilidadeDiaComponent } from './components/custom-calendar/gerenciar-disponibilidade-dia/gerenciar-disponibilidade-dia.component';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgxPaginationModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMaskModule,
        MatTabsModule,
        MatDatepickerModule,
        MatInputModule,
        MatNativeDateModule,
        FullCalendarModule,
        CardConsultaModule
    ],
    declarations: [
        AbpPaginationControlsComponent,
        AbpValidationSummaryComponent,
        AbpModalHeaderComponent,
        AbpModalFooterComponent,
        LocalizePipe,
        BusyDirective,
        EqualValidator,
        FormatTimePipe,
        ViewSituacaoPagamentoDialogComponent,
        OnlyNumberDirective,
        OnlyAlphanumericDirective,
        CpfCnpjValidator,
        RoleSelectionDialogComponent,
        CustomModalComponent,
        CustomModalBodyComponent,
        CustomModalFooterComponent,
        CustomModalHeaderComponent,
        CustomTogleComponent,
        CustomDropdownComponent,
        AccordionComponent,
        DefaultConveniosComponent,
        ActiveConvenioComponent,
        SuspendConvenioComponent,
        EditConvenioComponent,
        CreateConvenioComponent,
        FormEnderecoComponent,
        ShowDashIfNullPipe,
        CustomSetTextDialogComponent,
        ChatComponent,
        ChatCardComponent,
        ChatMessagesComponent,
        CpfCnpjPipe,
        CustomCardComponent,
        CardDashboardComponent,
        CardInformacoesPacienteComponent,
        DownloadFichaPacienteComponent,
        TelefonePipe,
        DefaultPrescricoesComponent,
        CustomCalendarComponent,
        AgendaComponent,
        CreateAgendaComponent,
        EditAgendaComponent,
        CreateEventoComponent,
        EditEventoComponent,
        DefaultConsultasComponent,
        DefaultConsultaComponent,
        CreateConsultaComponent,
        EditConsultaComponent,
        EditStatusConsultaComponent,
        VisualizarAnexosComponent,
        ModalVisualizarAnexosComponent,
        CreateHorarioDisponivelComponent,
        CustomDatepickerSelectedComponent,
        TornarPacienteVipComponent,
        EditPacienteVipComponent,
        DefaultAlergiasComponent,
        CreateAlergiaComponent,
        EditAlergiaComponent,
        DefaultPacienteAlergiasComponent,
        CreatePacienteAlergiaComponent,
        EditPacienteAlergiaComponent,
        VideoCallComponent,
        VideoCallOptionsComponent,
        RemarcarConsultaComponent,
        CardPlanoAccountComponent,
        MinhaAssinaturaComponent,
        CardPlanoComponent,
        RealizarPagamentoComponent,
        ExibirPlanoComponent,
        HistoricoAssinaturaComponent,
        ViewCustoAdicionalComponent,
        MetodosPagamentosComponent,
        HistoricoCobrancaCustoAdicionalComponent,
        ConveniosPacienteComponent,
        CreateConvenioPacienteComponent,
        EditConvenioPacienteComponent,
        ViewNotificacaoDialogComponent,
        BackButtonComponent,
        GraficoHeaderComponent,
        AnexarExameComponent,
        SuporteAssinaturaDigitalModalComponent,
        PacienteMonitoradoComponent,
        DashboardToggleComponent,
        FormPacienteComponent,
        VerificarCadastroPacienteComponent,
        HeaderFormCadastroPacienteComponent,
        DadosFormCadastroPacienteComponent,
        DataNascimentoFormCadastroPacienteComponent,
        ResponsavelFormCadastroPacienteComponent,
        AceitaTermosFormCadastroPacienteComponent,
        GerenciarDisponibilidadeDiaComponent,
    ],
    exports: [
        AbpPaginationControlsComponent,
        AbpValidationSummaryComponent,
        AbpModalHeaderComponent,
        AbpModalFooterComponent,
        LocalizePipe,
        BusyDirective,
        EqualValidator,
        FormatTimePipe,
        ViewSituacaoPagamentoDialogComponent,
        OnlyNumberDirective,
        OnlyAlphanumericDirective,
        CpfCnpjValidator,
        RoleSelectionDialogComponent,
        NgxPaginationModule,
        CustomModalComponent,
        CustomTogleComponent,
        CustomDropdownComponent,
        AccordionComponent,
        DefaultConveniosComponent,
        ShowDashIfNullPipe,
        CpfCnpjPipe,
        CustomSetTextDialogComponent,
        CustomCardComponent,
        CardDashboardComponent,
        CardInformacoesPacienteComponent,
        DownloadFichaPacienteComponent,
        TelefonePipe,
        DefaultPrescricoesComponent,
        CustomCalendarComponent,
        DefaultConsultasComponent,
        TornarPacienteVipComponent,
        EditPacienteVipComponent,
        CustomDatepickerSelectedComponent,
        CardPlanoAccountComponent,
        MinhaAssinaturaComponent,
        ConveniosPacienteComponent,
        BackButtonComponent,
        GraficoHeaderComponent,
        AnexarExameComponent,
        SuporteAssinaturaDigitalModalComponent,
        PacienteMonitoradoComponent,
        DashboardToggleComponent,
        FormPacienteComponent
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                MaskPipe,
                AppSessionService,
                AppUrlService,
                AppAuthService,
                LayoutStoreService,
                BuscaCnpjService,
                BuscaCepService,
                MercadoPagoService,
                TitleService,
                KsModalGalleryConfiguration,
                PacienteService,
                ProntuarioService,
                ClinicaService,
                MonitoramentoService,
                ValidarCpfService,
                StringExtensionService,
                ChatService,
                DataService,
                BryService,
                BryAuthService,
                TipoAssinaturaService,
                FotoPerfilService,
                PushNotficationService,
                CountNotificationService,
                ArvoreArquivoService,

                { provide: Window, useValue: window },
                { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
                { provide: DateAdapter, useClass: CustomDateAdapter },
                { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }
            ]
        };
    }
}
